var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareOr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5715_18208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5443 23.5444H3.03797C3.03797 23.5444 0.455688 23.5444 0.455688 20.9621V0.455811",
    stroke: "#E35205",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.486084 14.248H23.5443",
    stroke: "#E35205",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89103 2.64315C5.49505 2.64315 5.98471 2.1535 5.98471 1.54948C5.98471 0.945464 5.49505 0.455811 4.89103 0.455811C4.28702 0.455811 3.79736 0.945464 3.79736 1.54948C3.79736 2.1535 4.28702 2.64315 4.89103 2.64315Z",
    stroke: "#E35205",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93168 6.71395C9.5357 6.71395 10.0254 6.2243 10.0254 5.62028C10.0254 5.01626 9.5357 4.52661 8.93168 4.52661C8.32767 4.52661 7.83801 5.01626 7.83801 5.62028C7.83801 6.2243 8.32767 6.71395 8.93168 6.71395Z",
    stroke: "#E35205",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79736 6.71404L10.0252 0.455811",
    stroke: "#E35205",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.486084 19.686L4.61773 15.5544L6.98735 17.924L15.4025 9.50882L18.9266 13.0329L23.5443 8.38477",
    stroke: "#E35205",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5715_18208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareOr);
export default __webpack_public_path__ + "static/media/compare-or.cf1c30a84453d4bfc142eea66eb2eadb.svg";
export { ForwardRef as ReactComponent };